/* @flow */
import { List } from 'immutable';
import uuid from 'utils/uuid';

type ToastKind = 'success' | 'error';

export type Toast = {
  uuid: string,
  text: string,
  kind: ToastKind,
};

export type State = List<Toast>;
export const initialState: State = new List();

export default function reducer(state: State = initialState, action: *): State {
  switch (action.type) {
    case 'toasts/ADD':
      return state.push(action.toast);
    case 'toasts/REMOVE':
      return state.remove(state.indexOf(action.toast));
    default:
      return state;
  }
}

type AddAction = {
  type: 'toasts/ADD',
  toast: Toast,
};

export function add(toast: Toast): AddAction {
  return {
    type: 'toasts/ADD',
    toast,
  };
}

type RemoveAction = {
  type: 'toasts/REMOVE',
  toast: Toast,
};

export function remove(toast: Toast): RemoveAction {
  return {
    type: 'toasts/REMOVE',
    toast,
  };
}

// helper for the add action, to create new toast.
export function showToast(text: string, kind: 'success' | 'error'): AddAction {
  return add({ uuid: uuid(), text, kind });
}

// helper for the add action, to create toast from API response.
export function showAPIErrorToast(error: any): AddAction {
  let text;

  if (error.code === 'validation_error') {
    text = error.field_errors.map(err => err.messages.join(', ')).join(', ');
  } else if (error.message) {
    text = error.message;
  } else {
    text = 'An error occurred.';
  }

  return add({ uuid: uuid(), text, kind: 'error' });
}

// helper for the add action, to create toast from GQL response.
export function showGQLErrorToast(error: *): AddAction {
  let text;

  if (error.code === 'validation_error') {
    text = error.fieldErrors.map(err => err.message).join(', ');
  } else if (error.message) {
    text = error.message;
  } else {
    text = 'An error occurred.';
  }

  return add({ uuid: uuid(), text, kind: 'error' });
}

export type ToastActions = AddAction | RemoveAction;
